import { render } from "./TablesContext.vue?vue&type=template&id=047d11b5"
import script from "./TablesContext.vue?vue&type=script&lang=js"
export * from "./TablesContext.vue?vue&type=script&lang=js"

import "./TablesContext.vue?vue&type=style&index=0&id=047d11b5&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__